import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Report} from '../../components/reports/types';

export interface PermissionsProps {
  activeTenant: string,
  permissions: string[],
  availableTenants: SingleTenantProps[]
}

interface ReportsProps {
  reports: Report[]
}

interface PermissionsState extends PermissionsProps, ReportsProps {}

const initialState: PermissionsState = {
  activeTenant: '',
  permissions: [],
  availableTenants: [],
  reports: []
};

type SingleTenantProps = {
  id: number,
  industryCode: string,
  name: string,
  slug: string
}

export const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setPermissions: (state, action: PayloadAction<PermissionsProps>) => {
      const {
        permissions = [], activeTenant = '', availableTenants = []
      } = action.payload || {};

      state.permissions = [...permissions];
      state.availableTenants = [...availableTenants];
      state.activeTenant = activeTenant || '';
    },
    setActiveTenant: (state, action: PayloadAction<string>) => {
      state.activeTenant = action.payload;
    },
    setTenants: (state, action: PayloadAction<SingleTenantProps[]>) => {
      state.availableTenants = [...action.payload];
    },
    setTenantReports: (state, action: PayloadAction<ReportsProps>) => {
      const {reports = []} = action.payload || {};

      state.reports = [...reports];
    }
  }
});

export const {
  setPermissions,
  setActiveTenant,
  setTenants,
  setTenantReports
} = permissionsSlice.actions;


export default permissionsSlice.reducer;
